import { EVENTS } from '../config/constants.js';

/**
 * Get event based on d20 roll
 * @param {number} roll - The d20 roll result
 * @returns {Object} The event object
 */
export const getEvent = (roll) => {
  return EVENTS.find(e => roll >= e.roll[0] && roll <= e.roll[1]);
};
